import React from 'react';

function Equipments() {
  return (
    <div>
      <p>[Equipments]</p>
    </div>
  );
}

Equipments.propTypes = {};

export default Equipments;
